import React from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import { FillTheFieldErrorMessage, FormInput } from "@/shared/Components";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const ProfessionalActivities: React.FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`professionalActivities.${index}`} />
      <FormInput
        name={`professionalActivities.${index}.activity`}
        placeholder={t("contactsPage.activities.activity")}
      />
      <FormInput
        name={`professionalActivities.${index}.industry.name`}
        placeholder={t("contactsPage.activities.industry")}
      />
      <FormInput
        name={`professionalActivities.${index}.role`}
        placeholder={t("contactsPage.activities.role")}
      />
    </FieldLayout>
  );
};
